import { legalMachine, lmiUtilityRules } from '~/machines/legal-completion';
import { solarMachine } from '~/machines/solar-funnel';
import { utilityMachine } from '~/machines/utility-selection';
import { LDClient, LDFlags } from '~/providers';
import { fetchVnmTerms } from '~/services';
import { ContractTag } from '~/typings/graphql';
import { fetchContractLanguage } from '~/utils/fetch-contract-language';
import { getInitialState } from '~/utils/funnels';
import { ALLOWED_UTILITIES } from './allowed-utilities';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    user: {
      context: { showInviteCode: true, showPhone: true, requirePhone: true },
    },
    legal: { context: {} },
  }).withConfig({
    services: {
      legalMachine: legalMachine().withConfig({
        services: {
          fetchTerms: async context => {
            const terms = await fetchVnmTerms({
              stateId: context.funnelPacket.utility.state.id,
              utilityAccountId: context.funnelPacket.utilityAccount.id,
              contractTags: [ContractTag.SolarLandscape],
            });
            if (LDClient.variation(LDFlags.showOnlySolarLandscapeContracts)) {
              terms.vnmSolarProjectContracts = terms.vnmSolarProjectContracts.filter(
                c => c.tag === ContractTag.SolarLandscape,
              );
            }

            const { docuSignContracts, generalContracts, vnmSolarProjectContracts } = terms;
            const showLmi = terms.showLmi && lmiUtilityRules(context);
            const allSolarContracts = generalContracts
              ? vnmSolarProjectContracts?.concat(generalContracts)
              : vnmSolarProjectContracts;

            const unsignedSolarContracts = allSolarContracts?.filter(
              contractVersion =>
                !context.funnelPacket?.signedContractIds.includes(contractVersion.contractId),
            );
            return fetchContractLanguage(docuSignContracts, unsignedSolarContracts, showLmi);
          },
        },
      }),
      utilityMachine: utilityMachine().withConfig({
        guards: {
          shouldShowFriction: context => {
            const allowedUtilities: Number[] = ALLOWED_UTILITIES;
            return !allowedUtilities.includes(context.utilityId!);
          },
        },
      }),
    },
  });
